import Styles from '../UploadVideo.module.scss'
import cx from 'classnames'
import { VideoDuration } from 'components/VideoDuration/VideoDuration'
import { IMediaFile } from 'components/Design/UploadsTab/Types'

type VideoTileProps = {
  video: IMediaFile
  onVideoPress: (video: IMediaFile, needsDownload: boolean) => void
  isSelected: boolean
  needsDownload?: boolean
}

export const VideoTile = ({ video, onVideoPress, isSelected, needsDownload }: VideoTileProps) => (
  <div className={Styles.mediaFileContainer} onClick={() => onVideoPress(video, !!needsDownload)}>
    <img className={cx({ [Styles.selected]: isSelected })} src={video.thumbnail_url} alt={video.id} />
    {video.duration && <VideoDuration duration={video.duration} />}
  </div>
)
